import React, { useState, useEffect, useContext, useRef } from "react";
import "./transcriptDetail.css";
import { ReactComponent as Search } from "../../assets/search.svg";
import Script from "../../assets/script.svg";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { useLocation, useNavigate } from "react-router-dom";
import Highlighter from "react-highlight-words";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { createDoc } from "../../utils/pdfDoc";
import {
  editTranscript,
  getTransriptDetailByID,
  highlightTranscript,
  renameTranscript,
} from "../../services/transcriptService";
import {
  getAllPrompts,
  getAllPromptsWithoutPagination,
} from "../../services/promptService";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import Curogram from "../../assets/curogramIcon.png";
import Meet from "../../assets/meetIcon.png";
import Teams from "../../assets/teams.png";
import Zoom from "../../assets/zoom.svg";
import ScribeAi from "../../assets/mic.png";
import Tooltip from "../../components/ToolTip/ToolTip";
import {
  clearSummary,
  summarizeOpenAITranscript,
  summarizeTranscript,
} from "../../services/summaryService";
import AuthContext from "../../store/AuthContext";
import { filterAndReplace } from "../../utils/filterAndReplace";
import { formatText } from "../../utils/formatText";
import MagicalIcon from "../../assets/magical.png";
import AI from "../../assets/image001.png";
import { RotatingLines } from "react-loader-spinner";
import parse, { domToReact } from "html-react-parser";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TranscriptDetailScreen = () => {
  const navigate = useNavigate();
  const [searchWord, setSearchWord] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [transcriptName, setTranscriptName] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [transcriptDetail, setTranscriptDetail] = useState({});
  const [toBeHighlighted, setToBeHighlighted] = useState(null);
  const [clearTranscriptSummary, setClearTranscriptSummary] = useState(false);
  const [fetchSummary, setFetchSummary] = useState(false);
  const [includeSummary, setIncludeSummary] = useState(false);
  const [prevChat, setPrevChat] = useState([]);
  const [editIdx, setEditIdx] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [edit, setEdit] = useState(null);
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const firstMatchRef = useRef(null);
  const firstMatchFound = useRef(false);
  const intervalRef = useRef(null); // store the interval ID
  const searchWordRef = useRef(null);
  const [searchedDomElements, setsearchedDomElements] = useState([]);
  const [searchWordIndex, setSearchWordIndex] = useState(-1);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.startsWith("/")) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handlePromptSelect = (prompt) => {
    setInputValue(prompt.promptText);
    setShowDropdown(false);
  };

  useEffect(() => {
    const getTranscripts = async () => {
      try {
        const res = await getTransriptDetailByID(location.search.substring(1));
        if (res?.status === "success") {
          setTranscriptDetail(res?.result);
          setName(res?.result?.meetingName);
          setTranscriptName(res?.result?.meetingName);
          setPrevChat(
            filterAndReplace(
              JSON.parse(
                res?.result?.chatGptTextArray
                  ? res?.result?.chatGptTextArray
                  : "[]"
              ),
              ".Format the response nicely,using ** for bold,- for list items etc"
            )
          );

          if (res?.result?.isTranscriptionComplete) {
            clearInterval(intervalRef.current); // correctly clear it here
          }

          setMessages(
            res?.result?.rawTranscription
              ? JSON.parse(res?.result?.rawTranscription)
              : []
          );
        } else throw new Error("Fetching Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      } finally {
        setLoading(false);
      }
    };

    // intervalRef.current = setInterval(() => {
    getTranscripts();
    // }, 10000);

    // return () => {
    //   clearInterval(intervalRef.current);
    // };
  }, []);

  useEffect(() => {
    const getPrompts = async () => {
      try {
        const res = await getAllPromptsWithoutPagination();
        if (res?.status === "success") {
          setPrompts(res?.result ? res?.result : []);
        } else throw new Error("Fetching Prompts Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };
    getPrompts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        const res = await editTranscript(edit);
        if (res?.status === "success") {
          setEdit(null);
          setLoading(false);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        // setLoading(true);
        setEdit(null);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (edit !== null) updateTranscripts();
    // eslint-disable-next-line
  }, [edit]);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        const res = await highlightTranscript({
          id: location.search.substring(1),
          index: toBeHighlighted,
        });
        if (res?.status === "success") {
        } else throw new Error("Fetching Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (toBeHighlighted !== null) updateTranscripts();
    // eslint-disable-next-line
  }, [toBeHighlighted]);

  useEffect(() => {
    if (
      searchWordIndex !== -1 &&
      searchedDomElements.length > 0 &&
      searchedDomElements[searchWordIndex]
    ) {
      scrollToElementAtIndex(searchWordIndex);
    }
  }, [searchWordIndex, searchedDomElements]);

  function scrollToElementAtIndex(index) {
    const element = searchedDomElements[index];

    console.log("element", element);

    if (!element) return;

    const elementY =
      element.getBoundingClientRect().top +
      window.scrollY -
      window.innerHeight / 2;

    console.log(elementY);

    window.scrollTo({
      top: elementY,
      behavior: "smooth",
    });
  }

  function goToNext() {
    if (searchedDomElements.length === 0) return;

    const nextIndex = (searchWordIndex + 1) % searchedDomElements.length;
    setSearchWordIndex(nextIndex);
  }

  function goToPrevious() {
    if (searchedDomElements.length === 0) return;

    const prevIndex =
      (searchWordIndex - 1 + searchedDomElements.length) %
      searchedDomElements.length;
    setSearchWordIndex(prevIndex);
  }

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        if (inputValue === "") {
          toast("Please enter a propmt !!!");
          setFetchSummary(false);
          return;
        }

        let res = null;

        if (authCtx?.user?.AI === "BASTIONGPT") {
          res = await summarizeTranscript({
            id: location.search.substring(1),
            prompt: inputValue,
          });
        } else {
          res = await summarizeOpenAITranscript({
            id: location.search.substring(1),
            prompt: inputValue,
          });
        }

        if (res?.status === "success") {
          setTranscriptDetail(res?.result);
          setName(res?.result?.meetingName);
          setTranscriptName(res?.result?.meetingName);
          toast("Transcript Generated");
          setPrevChat(
            filterAndReplace(
              JSON.parse(
                res?.result?.chatGptTextArray
                  ? res?.result?.chatGptTextArray
                  : "[]"
              ),
              ".Format the response nicely,using ** for bold,- for list items etc"
            )
          );
          setMessages(
            res?.result?.rawTranscription
              ? JSON.parse(res?.result?.rawTranscription)
              : []
          );
          setFetchSummary(false);
          setInputValue("");
        } else throw new Error("Summarizing Failed");
      } catch (e) {
        setFetchSummary(false);
        setInputValue("");
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (fetchSummary === true) updateTranscripts();

    // eslint-disable-next-line
  }, [fetchSummary]);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        const res = await clearSummary({ id: location.search.substring(1) });
        if (res?.status === "success") {
          setTranscriptDetail(res?.result);
          setName(res?.result?.meetingName);
          setTranscriptName(res?.result?.meetingName);
          setPrevChat(
            filterAndReplace(
              JSON.parse(
                res?.result?.chatGptTextArray
                  ? res?.result?.chatGptTextArray
                  : "[]"
              ),
              ".Format the response nicely,using ** for bold,- for list items etc"
            )
          );
          setMessages(
            res?.result?.rawTranscription
              ? JSON.parse(res?.result?.rawTranscription)
              : []
          );
          setClearTranscriptSummary(false);
          setInputValue("");
          // toast(res.message);
        } else throw new Error("Clearing Summary Failed");
      } catch (e) {
        setClearTranscriptSummary(false);
        setInputValue("");
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (clearTranscriptSummary !== false) updateTranscripts();
    // eslint-disable-next-line
  }, [clearTranscriptSummary]);

  const updateName = async () => {
    if (name === "") return toast("Name Cannot Be Empty");

    try {
      const res = await renameTranscript({
        id: location.search.substring(1),
        name,
      });
      if (res?.status === "success") {
        setTranscriptName(name);
      } else throw new Error("Update Failed");
    } catch (e) {
      setLoading(true);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  // Scroll to the first match when the search word changes
  useEffect(() => {
    if (searchWord && firstMatchRef.current) {
      firstMatchRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [searchWord]);

  return (
    <>
      <ToastContainer />
      <NavBar />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "200px 1fr",
          height: "-webkit-fill-available",
        }}
      >
        <SideBar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            background: "#fff",
          }}
        >
          <div
            style={{
              padding: "20px 50px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                height: "30px",
                width: "30px",
                background: "#f8f8f8",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                aspectRatio: "1",
              }}
              onClick={() => {
                // if (
                //   transcriptDetail?.meetingPlatform &&
                //   transcriptDetail.meetingPlatform === "SCRIBE-AI"
                // ) {
                //   navigate("/record");
                // } else {
                //   navigate("/");
                // }
                window.history.back();
              }}
            >
              <ion-icon
                name="arrow-back-outline"
                style={{ height: "20px", width: "20px" }}
              ></ion-icon>
            </div>

            <div
              style={{
                display: "flex",
                // height: "30px",
                justifyContent: "center",
                flexDirection: "column",
                marginLeft: "30px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <textarea
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // prevent newline
                      updateName();
                      e.target.blur(); // remove focus
                    }
                  }}
                  style={{
                    width: "500px",
                    flex: "initial",
                    resize: "none",
                    overflowWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                />
                {name !== transcriptName && (
                  <ion-icon
                    name="checkmark-done-circle-outline"
                    style={{
                      color: "green",
                      marginLeft: "10px",
                      fontSize: 20,
                      verticalAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      updateName();
                    }}
                  ></ion-icon>
                )}
              </div>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <textarea
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  style={{
                    width: `${(name?.length + 5) * 8}px`,
                    flex: "initial",
                  }}
                /> */}

              {/* </div> */}
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "300",
                  textAlign: "left",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  {transcriptDetail.meetingPlatform === "CUROGRAM" ? (
                    <img
                      style={{ height: "20px" }}
                      src={Curogram}
                      alt="Curogram"
                      data-tag="allowRowEvents"
                    />
                  ) : transcriptDetail.meetingPlatform === "MEET" ? (
                    <img
                      style={{ height: "20px" }}
                      src={Meet}
                      alt="Meet"
                      data-tag="allowRowEvents"
                    />
                  ) : transcriptDetail.meetingPlatform === "ZOOM" ? (
                    <img
                      style={{ height: "20px" }}
                      src={Zoom}
                      data-tag="allowRowEvents"
                      alt="Zoom"
                    />
                  ) : transcriptDetail.meetingPlatform === "SCRIBE-AI" ? (
                    <img
                      style={{ height: "20px" }}
                      src={ScribeAi}
                      data-tag="allowRowEvents"
                      alt="ScribeAi"
                    />
                  ) : (
                    <img
                      style={{ height: "20px" }}
                      src={Teams}
                      data-tag="allowRowEvents"
                      alt="MSTeams"
                    />
                  )}
                </div>

                {transcriptDetail?.patientName !== "Unknown" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "1px",
                    }}
                  >
                    <ion-icon name="mail-outline"></ion-icon>{" "}
                    {transcriptDetail?.patientName}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <ion-icon name="calendar-clear-outline"></ion-icon>
                  {moment(transcriptDetail.createdAt).format("dddd MMMM Do")}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <ion-icon name="time-outline"></ion-icon>{" "}
                  {moment(transcriptDetail.createdAt).format("h:mm a")}
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                width: "450px",
                height: "40px",
                background: "white",
                borderRadius: 5,
                border: "1px solid #bdbdbd",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                onChange={(e) => {
                  const val = e.target.value;
                  searchWordRef.current = val;
                  // firstMatchFound.current = false;
                  // setSearchWord(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    e.preventDefault();
                    setSearchWord(searchWordRef.current);

                    const elements = Array.from(
                      document.getElementsByClassName("highlight")
                    );

                    setsearchedDomElements(elements);

                    setSearchWordIndex(-1);

                    goToNext();
                  }
                }}
                placeholder="Search Across The Transcript"
                style={{
                  height: "38px",
                  color: "rgba(126, 137, 168, 1)",
                  fontSize: "15px",
                  padding: "10px",
                }}
              />
              <Search style={{ marginRight: 10 }} />
            </div>

            <div style={{ position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  width: "80px",
                  height: "40px",
                  background: "white",
                  borderRadius: 5,
                  marginLeft: "20px",
                  border: "1px solid rgba(110, 117, 255, 1)",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "rgba(110, 117, 255, 1)",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => {
                  setIsOpen((open) => !open);
                }}
              >
                Export
              </div>
              {isOpen && (
                <div className="exportDD">
                  Export Transcript
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      fontSize: 10,
                      margin: "5px 0",
                      width: "100%",
                      gap: 8,
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{
                        padding: 0,
                        flex: "none",
                        borderRadius: 10,
                        height: "10px",
                        width: "20px",
                        margin: "5px",
                      }}
                      className="summaryCheckbox"
                      checked={includeSummary}
                      onChange={() => {
                        setIncludeSummary(
                          !includeSummary &&
                            transcriptDetail.summarizedTranscription !== ""
                        );
                      }}
                    ></input>{" "}
                    Include Summary
                  </div>
                  <p style={{ fontSize: "12px", color: "#333" }}>
                    Select Format
                  </p>
                  <select>
                    <option>PDF</option>
                  </select>
                  <button
                    style={{
                      color: "white",
                      width: "100%",
                      marginTop: "10px",
                      padding: "5px 0",
                      borderRadius: "5px",
                      border: "none",
                      background:
                        "linear-gradient(90deg, #6E75FF 0%, #C66EFF 100%)",
                    }}
                    onClick={() => {
                      var doc = createDoc({
                        providername: transcriptDetail.providerName,
                        name: transcriptDetail.patientName,
                        time: moment(transcriptDetail.createdAt).format("LLLL"),
                        messages,
                        includeSummary,
                        summarizedTranscript:
                          transcriptDetail.summarizedTranscription,
                        url: authCtx?.user?.organization?.imageData,
                      });
                      pdfMake.createPdf(doc).open();
                    }}
                  >
                    Export
                  </button>
                </div>
              )}
            </div>
          </div>

          <div style={{ background: "#fff", flex: 1 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "15px",
                boxShadow: " 0px -1px 0px 0px #EEEEEE inset",
                paddingLeft: "30px",
                color: "#707070",
                fontSize: "15px",
                fontWeight: "500",
                background: "#f8f8f8",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: "500",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "15px",
                    fontWeight: "500",
                    alignItems: "center",
                  }}
                >
                  <img src={Script} alt="Script"></img>
                  Transcript
                  <Tooltip content="Copy Transcript" direction="top">
                    <button
                      style={{
                        marginLeft: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        document.body.style.cursor = "wait";

                        async function copyToClipboard(text) {
                          try {
                            await navigator.clipboard.writeText(text);
                            toast("Copied to clipboard successfully!!");
                          } catch (err) {
                            console.error("Failed to copy text:", err);
                            toast("Failed to copy text:" + err);
                          }
                        }

                        await copyToClipboard(
                          messages.map((arr) => arr.text).join(" ")
                        );
                        document.body.style.cursor = "default";
                      }}
                    >
                      <ion-icon
                        name="copy-outline"
                        style={{ fontSize: 16, color: "gray" }}
                      ></ion-icon>
                    </button>
                  </Tooltip>
                  <Tooltip content="Use InteliDoc-AI" direction="top">
                    <button
                      onClick={() => {
                        const data = JSON.parse(
                          localStorage.getItem("defaultPromptNew")
                        );

                        if (data) {
                          navigate("/InteliDoc-GPT", {
                            state: {
                              transcription: messages
                                .map((arr) => arr.text)
                                .join(" "),
                              prompt: data,
                            },
                          });
                        } else {
                          if (prompts.length > 0) {
                            navigate("/InteliDoc-GPT", {
                              state: {
                                transcription: messages
                                  .map((arr) => arr.text)
                                  .join(" "),
                                prompt: prompts[0],
                              },
                            });
                          } else {
                            navigate("/InteliDoc-GPT", {
                              state: {
                                transcription: messages
                                  .map((arr) => arr.text)
                                  .join(" "),
                              },
                            });
                          }
                        }
                      }}
                      className="flex justify-center items-center"
                      style={{ marginLeft: "10px" }}
                    >
                      <img
                        style={{
                          width: "16px",
                          height: "16px",
                          mixBlendMode: "darken",
                        }}
                        src={AI}
                        alt="Script"
                      ></img>
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: "500",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "15px",
                    fontWeight: "500",
                    alignItems: "center",
                  }}
                >
                  Summary
                  <Tooltip content="Copy Summary" direction="top">
                    <button
                      style={{
                        marginLeft: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        document.body.style.cursor = "wait";

                        async function copyToClipboard(text) {
                          try {
                            await navigator.clipboard.writeText(text);
                            toast("Copied to clipboard successfully!!");
                          } catch (err) {
                            console.error("Failed to copy text:", err);
                            toast("Failed to copy text:" + err);
                          }
                        }

                        await copyToClipboard(
                          transcriptDetail.summarizedTranscription
                        );
                        document.body.style.cursor = "default";
                      }}
                    >
                      <ion-icon
                        name="copy-outline"
                        style={{ fontSize: 16, color: "gray" }}
                      ></ion-icon>
                    </button>
                  </Tooltip>
                  <Tooltip content="Use default Prompt" direction="top">
                    <button
                      onClick={async () => {
                        const data = JSON.parse(
                          localStorage.getItem("defaultPromptNew")
                        );

                        const result = prompts.find((p) => p.id === data.id);

                        if (result) {
                        } else if (prompts.length === 0) {
                          toast("No Default Prompt Found!");
                          return;
                        } else {
                          result = prompts[0];
                        }

                        setInputValue(result.promptText);
                        setFetchSummary(true);
                      }}
                      className="flex justify-center items-center"
                      style={{ marginLeft: "10px" }}
                    >
                      <img
                        style={{ width: "16px", height: "16px" }}
                        src={MagicalIcon}
                        alt="Auto Fill"
                      ></img>
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
            {loading ? (
              <div id="svg-container">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  color="red"
                  strokeColor="grey"
                  strokeWidth="4"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}
                className="details-section"
              >
                <div
                  style={{
                    minHeight: "510px",
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "30px 15px",
                    flex: 1,
                    order: "-1",
                  }}
                >
                  {messages.map((m, index) => {
                    return (
                      <div
                        key={`${index}` + "message"}
                        className="message-container"
                        style={{
                          background:
                            m.highlight === true ? "lightyellow" : "white",
                          borderRadius: "10px",
                          position: "relative",
                        }}
                      >
                        {editIdx !== index && (
                          <Highlighter
                            highlightClassName="highlight"
                            searchWords={[searchWord]}
                            autoEscape={true}
                            textToHighlight={m.text ? m.text : m}
                            highlightTag={({ children }) => {
                              // Track first occurrence of the search word
                              if (
                                !firstMatchFound.current &&
                                searchWord &&
                                children
                                  .toLowerCase()
                                  .includes(searchWord.toLowerCase())
                              ) {
                                firstMatchFound.current = true;
                                return (
                                  <span
                                    className="highlight"
                                    ref={firstMatchRef}
                                  >
                                    {children}
                                  </span>
                                );
                              }
                              return (
                                <span className="highlight">{children}</span>
                              );
                            }}
                          />
                        )}
                        <div
                          style={{
                            display:
                              editIdx === index ? "inline-block" : "none",
                            position: "relative",
                            width: "100%",
                          }}
                        >
                          <textarea
                            value={editValue}
                            onChange={(e) => {
                              setEditValue(e.target.value);
                            }}
                            style={{
                              height: "80px",
                              width: "100%",
                              outline: "none",
                              border: "1px solid gray",
                              padding: "5px",
                              borderRadius: "8px",
                              resize: "none",
                              overflow: "hidden",
                            }}
                          />
                          <button
                            onClick={() => {
                              setEditIdx(null);
                              setEditValue("");
                            }}
                            style={{
                              position: "absolute",
                              bottom: "10px",
                              right: "-40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "rgb(225, 51, 51)",
                              background: "rgb(255, 245, 245)",
                              border: "1px solid rgb(225, 51, 51)",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <ion-icon
                              name="close-outline"
                              style={{ fontSize: 16 }}
                            ></ion-icon>
                          </button>
                          <button
                            style={{
                              position: "absolute",
                              bottom: "10px",
                              right: "-20px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "rgb(56, 142, 59)",
                              background: "rgb(232, 245, 233)",
                              border: "1px solid rgb(56, 142, 59)",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEdit({
                                id: location.search.substring(1),
                                index: editIdx,
                                value: editValue,
                              });
                              setEditIdx(null);
                              setEditValue("");
                            }}
                          >
                            <ion-icon
                              name="checkmark-outline"
                              style={{ fontSize: 16 }}
                            ></ion-icon>
                          </button>
                        </div>
                        <div className="editButton">
                          <Tooltip content="Click to edit !!" direction="left">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/1159/1159633.png"
                              onClick={() => {
                                setEditIdx(editIdx === index ? null : index);
                                setEditValue(m.text);
                              }}
                              style={{ height: 16 }}
                              alt="edit-text"
                            ></img>
                          </Tooltip>
                        </div>
                        {m.highlight === true ? (
                          <div className="highlightButton highlight-active">
                            <Tooltip
                              content="Double click to remove highlight !!"
                              direction="left"
                            >
                              <ion-icon
                                name="bookmarks"
                                onDoubleClick={() => {
                                  setMessages((prevMessages) =>
                                    prevMessages.map((m, idx) => {
                                      if (idx === index) m.highlight = false;
                                      return m;
                                    })
                                  );
                                  setToBeHighlighted(index);
                                }}
                              ></ion-icon>
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="highlightButton">
                            <Tooltip
                              content="Double click to highlight !!"
                              direction="left"
                            >
                              <ion-icon
                                name="bookmarks-outline"
                                onDoubleClick={() => {
                                  setMessages((prevMessages) =>
                                    prevMessages.map((m, idx) => {
                                      if (idx === index) m.highlight = true;
                                      return m;
                                    })
                                  );
                                  setToBeHighlighted(index);
                                }}
                              ></ion-icon>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    minHeight: "510px",
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "0px 30px 15px",
                    flex: 1,
                  }}
                >
                  {fetchSummary === true ? (
                    <div id="svg-container">
                      <RotatingLines
                        visible={true}
                        height="96"
                        width="96"
                        color="red"
                        strokeColor="grey"
                        strokeWidth="4"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  ) : transcriptDetail.isTranscriptionComplete === true ? (
                    <div>
                      <div
                        style={{
                          position: "sticky",
                          top: 0,
                          left: 0,
                          width: "100%",
                          zIndex: 999, // Adjust the z-index as needed
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 5,
                          background: "#fff",
                          padding: "15px 0px",
                          margin: "0px 15px 0px 0px",
                        }}
                      >
                        <div className="prompt-input-container">
                          <div className="input-wrapper">
                            <input
                              type="text"
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder='Type a message or type "/" to select a prompt . . . '
                            />
                            {showDropdown && (
                              <div className="dropdown">
                                {prompts.map((prompt, index) => (
                                  <div
                                    key={index + "-prompt"}
                                    className="dropdown-item"
                                    onClick={() => handlePromptSelect(prompt)}
                                  >
                                    {prompt.promptName}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "100px",
                            borderRadius: 5,
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: 14,
                            height: 30,
                            // background: "white",
                            border: "1px solid rgba(110, 117, 255, 1)",
                            // color: "rgba(110, 117, 255, 1)",
                            backgroundColor: "gray",
                            color: "#fff",
                          }}
                          onClick={() => {
                            setFetchSummary(true);
                          }}
                        >
                          Generate
                        </div>
                        {transcriptDetail.summarizedTranscription !== "" && (
                          <div
                            style={{
                              display: "flex",
                              width: "100px",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              fontSize: 14,
                              height: 30,
                              background: "white",
                              border: "1px solid rgba(110, 117, 255, 1)",
                              color: "rgba(110, 117, 255, 1)",
                            }}
                            onClick={() => {
                              setClearTranscriptSummary(true);
                            }}
                          >
                            Clear
                          </div>
                        )}
                      </div>

                      {prevChat?.map((chat, index) => (
                        <div key={index + "-chat"}>
                          {chat.role === "user" ? (
                            <>
                              {parse(chat.content, {
                                replace: (domNode) => {
                                  if (domNode.type === "text") {
                                    return (
                                      <Highlighter
                                        highlightClassName="highlight"
                                        searchWords={[searchWord]}
                                        autoEscape={true}
                                        textToHighlight={domNode.data}
                                        highlightTag={({ children }) => {
                                          if (
                                            !firstMatchFound.current &&
                                            searchWord &&
                                            children
                                              .toLowerCase()
                                              .includes(
                                                searchWord.toLowerCase()
                                              )
                                          ) {
                                            firstMatchFound.current = true;
                                            return (
                                              <span
                                                className="highlight"
                                                ref={firstMatchRef}
                                              >
                                                {children}
                                              </span>
                                            );
                                          }
                                          return (
                                            <span className="highlight">
                                              {children}
                                            </span>
                                          );
                                        }}
                                      />
                                    );
                                  }
                                },
                              })}
                              <br />
                              <hr />
                              <br />
                            </>
                          ) : (
                            <>
                              {parse(formatText(chat.content), {
                                replace: (domNode) => {
                                  if (domNode.type === "text") {
                                    return (
                                      <Highlighter
                                        highlightClassName="highlight"
                                        searchWords={[searchWord]}
                                        autoEscape={true}
                                        textToHighlight={domNode.data}
                                        highlightTag={({ children }) => {
                                          if (
                                            !firstMatchFound.current &&
                                            searchWord &&
                                            children
                                              .toLowerCase()
                                              .includes(
                                                searchWord.toLowerCase()
                                              )
                                          ) {
                                            firstMatchFound.current = true;
                                            return (
                                              <span
                                                className="highlight"
                                                ref={firstMatchRef}
                                              >
                                                {children}
                                              </span>
                                            );
                                          }
                                          return (
                                            <span className="highlight">
                                              {children}
                                            </span>
                                          );
                                        }}
                                      />
                                    );
                                  }
                                },
                              })}
                              <br />
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        height: "40px",
                        background: "white",
                        borderRadius: 5,
                        justifyContent: "center",
                        alignItems: "center",
                        color: "rgba(110, 117, 255, 1)",
                        cursor: "pointer",
                        position: "relative",
                        fontWeight: "500",
                      }}
                    >
                      Transcription Is Still In Progress . Summary can be
                      generated once it is finished !!!
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TranscriptDetailScreen;
